import angular from 'angular'
import component from './component'
import PlanningBodyController from './controller'

export default angular
  .module('ellipsis.planningBody', [])
  .component('planningBody', component)
  .controller('PlanningBodyController', PlanningBodyController)
